import { Box } from "@outschool/backpack";
import { fasExclamationTriangle } from "@outschool/icons";
import { Icon } from "@outschool/ui-legacy-component-library";
import React from "react";

interface LoginUserFeedbackProps {
  userFeedbackMessage?: String;
  isError: Boolean;
}

export default function LoginUserFeedback({
  userFeedbackMessage,
  isError
}: LoginUserFeedbackProps) {
  if (!userFeedbackMessage) {
    return null;
  }
  return (
    <Box
      sx={{
        justifySelf: "center",
        padding: "15px",
        background: !isError
          ? "rgba(253, 200, 64, 0.1)"
          : "rgba(241, 93, 93, 0.07)",
        border: !isError
          ? "1px solid rgba(253, 200, 64, 0.4)"
          : "1px solid rgba(241, 93, 93, 0.35)",
        borderRadius: "8px",
        width: "100%"
      }}
    >
      <Icon
        size={16}
        sx={{
          color: !isError ? "#fdc840" : "#f15d5d",
          position: "absolute",
          marginTop: "3px"
        }}
        icon={fasExclamationTriangle}
      />
      <Box
        sx={{
          paddingLeft: "30px"
        }}
      >
        {userFeedbackMessage}
      </Box>
    </Box>
  );
}
